import isEqual from 'lodash/isEqual';
import CommonValidation from '../Validation/AutoSavings/CommonValidation';
import { b64DecodeUnicode } from '../Utils/b64DecodeUnicode';

const userID = '6cc310a4-ec70-11e9-81b4-2a2ae2dbcce4';

export default class BrowserStorage {
  static handleDocumentLocalStorage = (stateName, value, message, defaultForm, form = '') => {
    try {
      const data = BrowserStorage.getLocalStorageValues(defaultForm, form);
      data[stateName] = { value, message };
      localStorage.setItem(userID.toString() + form, btoa(JSON.stringify(data)));
    } catch (e) { console.error(e); }
  }

  static handleSectionLocalStorageUpdate = (sectionName, sectionValue, defaultForm, form = '') => {
    try {
      const data = BrowserStorage.getLocalStorageValues(defaultForm, form);
      data[sectionName] = sectionValue;
      localStorage.setItem(userID.toString() + form, btoa(JSON.stringify(data)));
    } catch (e) { console.error(e); }
  }

  static getLocalStorageValues = (defaultForm, form = '', onLoad = false) => {
    let data = { ...defaultForm };
    try {
      const formData = localStorage.getItem(userID.toString() + form);
      if (formData) {
        data = JSON.parse(b64DecodeUnicode(formData));
      }

      if (!isEqual(Object.keys(data).sort(), Object.keys(defaultForm).sort())) {
        data = { ...defaultForm };
        localStorage.setItem(userID.toString() + form, btoa(JSON.stringify(defaultForm)));
      } else if (!!onLoad && Object.keys(data.vehicleState).length > 1) {
        const vehiclesKeys = Object.keys(data.vehicleState);
        const vehiclesAmount = vehiclesKeys.length;
        for (let i = 0; i < vehiclesAmount; i += 1) {
          let valid = true;
          let result = CommonValidation.validateYear(data.vehicleState[vehiclesKeys[i]].year.value);
          valid = result;
          result = CommonValidation.makeValidation(data.vehicleState[vehiclesKeys[i]].make.value);
          valid = valid && result.valid;
          result = CommonValidation.modelValidation(data.vehicleState[vehiclesKeys[i]].model.value);
          valid = valid && result.valid;
          result = CommonValidation.trimValidation(data.vehicleState[vehiclesKeys[i]].trim.value);
          valid = valid && result.valid;
          if (!valid && +vehiclesKeys[i] !== 1) {
            delete data.vehicleState[vehiclesKeys[i]];
          }
        }
      }

      if (!!data.vehicleState && !Object.keys(data.vehicleState).some((key) => +key === 1)) {
        data.vehicleState[1] = {};
      }
    } catch (e) { console.error(e); }

    return data && typeof data === 'object' ? data : defaultForm;
  }

  static saveToLocalStorage = (name, value) => {
    localStorage.setItem(name, value);
  };

  static getFromLocalStorage = (name, defaultValue) => {
    if (localStorage.getItem(name)) {
      return localStorage.getItem(name);
    }
    return defaultValue;
  };

  static clearLocalStorage = (name, value) => {
    const lastClear = localStorage.getItem('lastClear');
    const currentDate = (new Date()).getTime();

    if ((currentDate - lastClear) > 1000 * 60 * 60 * 30) {
      localStorage.clear(name, value);
      localStorage.setItem('lastClear', currentDate);
    }
  };
}
